import { z } from 'zod';
import { PaymentTypeSchema } from './receipts.js';
/** Reference to a receipt in Arbox; used as input to POST /api/deposits. */
export const ReceiptRefSchema = z.object({
    external_receipt_id: z.string(),
});
export const CreateDepositRequestSchema = z.object({
    /** Inferred from header location picker; server validates against locations(box_id, id). */
    location_id: z.number(),
    /** Header project picker. Ignored unless the box manages projects. */
    project_id: z.number().optional(),
    /** 'YYYY-MM-DD'. Defaults to today on the client; server validates not-in-future. */
    deposit_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    /** Per-box users_boxes_id of the depositor (= `arbox_users_boxes_id`
     *  column on staff_members). May be null when no depositor is picked. */
    depositor_arbox_users_boxes_id: z.number().nullable().optional(),
    notes: z.string().max(1000).nullable().optional(),
    receipt_refs: z.array(ReceiptRefSchema).min(1),
});
export const PdfStatusSchema = z.enum(['pending', 'ready', 'failed']);
export const DepositSummarySchema = z.object({
    id: z.number(),
    location_id: z.number(),
    project_id: z.number(),
    deposit_number: z.number(),
    deposit_date: z.string(),
    /** ISO timestamp of when the row was inserted; used for the time column. */
    created_at: z.string(),
    cash_total: z.number(),
    checks_total: z.number(),
    grand_total: z.number(),
    currency: z.string(),
    pdf_status: PdfStatusSchema,
    cancelled_at: z.string().nullable(),
    notes: z.string().nullable(),
    /** users_boxes.full_name of whoever clicked Create Deposit. */
    created_by_name: z.string().nullable(),
    /** users_boxes.full_name of the chosen physical depositor (optional in input). */
    depositor_name: z.string().nullable(),
});
export const DepositReceiptSchema = z.object({
    id: z.number(),
    deposit_id: z.number(),
    external_receipt_id: z.string(),
    receipt_number: z.string(),
    customer_name: z.string(),
    customer_external_id: z.string().nullable(),
    payment_type: PaymentTypeSchema,
    amount: z.number(),
    currency: z.string(),
    issue_date: z.string(),
    due_date: z.string().nullable(),
    check_number: z.string().nullable(),
    bank_code: z.string().nullable(),
    branch_number: z.string().nullable(),
    account_number: z.string().nullable(),
});
export const DepositDetailSchema = z.object({
    deposit: DepositSummarySchema,
    receipts: z.array(DepositReceiptSchema),
});
export const ListDepositsQuerySchema = z.object({
    location_id: z.coerce.number(),
    project_id: z.coerce.number().optional(),
    from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    search: z.string().optional(),
    /** 'all' (default) | 'active' | 'cancelled'. Drives the Tab B status filter. */
    status: z.enum(['all', 'active', 'cancelled']).default('all'),
});
export const CancelDepositRequestSchema = z.object({
    reason: z.string().max(500).optional(),
});
//# sourceMappingURL=deposits.js.map